export default __webpack_public_path__ + "static/media/declined.0ea96a38.svg";